var React = require('react');

function ArrowsAngle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.332 4H23.9987V10.6667","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.6667 24.0002H4V17.3335","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M24.0004 4L16.2227 11.7778","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M4 23.9999L11.7778 16.2222","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

ArrowsAngle.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = ArrowsAngle;

ArrowsAngle.default = ArrowsAngle;
